(() => {
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (reduced || !('IntersectionObserver' in window)) return;
  const observer = new IntersectionObserver(entries => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {entry.target.classList.add('is-seen');observer.unobserve(entry.target);}
    });
  }, {threshold: 0.1});
  const observe = root => root.querySelectorAll('.palier-reveal').forEach(el => observer.observe(el));
  observe(document);
  document.addEventListener('shopify:section:load', event => observe(event.target));
})();
